import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { AudioManager } from "./scenes/AudioManager";
import { BoardManager } from "./scenes/board-scene/BoardManager";
import { MenuLayer } from "./scenes/board-scene/MenuLayer";
import { SplashScene } from "./scenes/splash-scene/SplashScene";

export class GameManager {
    public static resize() {
        GameVars.currentScene.time.delayedCall(250, function(): void {
            const canvas = document.querySelector("canvas");
            
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            canvas.style.width = windowWidth + "px";
            canvas.style.height = windowHeight + "px";

            GameVars.currentScene.scale.refresh();
        }, [], this);
    }

    public static init(): void {

        GameVars.intitialised = true;
        GameVars.startFrom = 5;

        if (GameVars.desktop) {

            GameVars.scaleY = 1;
            GameVars.aspectRatio = 1;
        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            GameVars.aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameVars.gameHeight / GameVars.gameWidth) / GameVars.aspectRatio;
        }

        window["GD_OPTIONS"] = {
            "debug": false,
            "gameId": "4826046e52274359ad5921f59f322293",
            "onEvent": function(event) {
                switch (event.name) {
                    case "SDK_GAME_START":
                        AudioManager.forceUnmute();

                        switch (GameVars.addType) {
                            case GameConstants.ADD_START_PLAY: {
                                SplashScene.currentInstance.clickPlayLogic();
                            break; }
                            case GameConstants.ADD_TUTORIAL_PLAY: {
                                SplashScene.currentInstance.clickTutorialLogic();
                            break; }
                            case GameConstants.ADD_FIRST_TUTORIAL: {
                                GameManager.openTutorialFirst();
                            break; }
                            case GameConstants.ADD_GO_HOME_PAUSE: {
                               MenuLayer.clickHomeLogic();
                            break; }
                            case GameConstants.ADD_RESTART_GAME_PAUSE: {
                                MenuLayer.clickRestartLogic();
                             break; }
                             case GameConstants.ADD_BACK_PAUSE: {
                                BoardManager.hideMenu();
                             break; }
                             case GameConstants.ADD_GO_HOME: {
                                GameManager.enterSplashScene(); 
                             break; }
                             case GameConstants.ADD_RESTART_GAME: {
                                GameManager.enterBoardScene(false); 
                             break; }
                        }
                        GameVars.addType = 0;
                        break;
                    case "SDK_GAME_PAUSE":
                        AudioManager.forceMute();
                        break;
                    case "SDK_GDPR_TRACKING":
                        // this event is triggered when your user doesn't want to be tracked
                        break;
                    case "SDK_GDPR_TARGETING":
                        // this event is triggered when your user doesn't want personalised targeting of ads and such
                        break;
                }
            },
        };
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://html5.api.gamedistribution.com/main.min.js';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'gamedistribution-jssdk'));

        GameManager.readGameData();
    }

    public static setStartFrom(value: number): void {

        GameVars.startFrom = value;
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        highscore: 0,
                        bestValue: 0,
                        startTutorial: true
                    };
                }

                GameManager.startGame();
            }
        );
    }

    public static restoreGameData(): void {

        GameVars.gameData = {
            muted: false,
            highscore: 0,
            bestValue: 0,
            startTutorial: true
        };

        GameManager.writeGameData();
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {
        if (GameVars.gameData.startTutorial) {
            let w = <any> window;
            if (typeof w.gdsdk !== 'undefined' && w.gdsdk.showAd !== 'undefined') {
                GameVars.addType = GameConstants.ADD_FIRST_TUTORIAL;
                AudioManager.forceMute();
                w.gdsdk.showAd();
            }
            else {
               GameManager.openTutorialFirst();
            }
        } else {
            GameManager.enterSplashScene();
            // GameManager.enterBoardScene(false);
        }
    }

    public static openTutorialFirst(): void {
        GameManager.enterBoardScene(true);
        AudioManager.play("BackgroundMusic", true);
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static enterLevelSelectionScene(): void {

        GameVars.currentScene.scene.start("LevelSelectionScene");
    }

    public static enterBoardScene(tutorial: boolean): void {

        GameVars.onTutorial = tutorial;

        GameVars.currentScene.scene.start("BoardScene");
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
